import Vue from 'vue';
import VueI18n from 'vue-i18n';
import { createI18n } from 'vue-i18n-bridge';
import { camelizeKeys } from 'humps';
import {
  Checkbox, Field, Input, Icon, Loading, Button,
  Dropdown, Datepicker, Dialog, Radio, Switch, Toast, Numberinput, Select, Steps, Table, Tag, Taginput, Tooltip,
} from 'buefy';
import VModal from 'vue-js-modal/dist/index.nocss.js';
import 'vue-js-modal/dist/styles.css';
import ActionCableVue from 'actioncable-vue';
import { rutInputDirective } from 'vue-dni';
import Multiselect from 'vue-multiselect';
import InlineSvg from 'vue-inline-svg';
import VueCookies from 'vue-cookies';
import '@mdi/font/css/materialdesignicons.css';
import '@/css/buefy.scss';
import { createPinia, PiniaVuePlugin } from 'pinia';

import navbar from '@/src/components/navbar.vue';
import MembersList from '@/src/components/members-list.vue';
import BankMovements from '@/src/components/bank-movements/bank-movements.vue';
import FintocWidget from '@/src/components/bank-accounts/fintoc-widget.vue';
import SessionHandler from '@/src/components/session-handler.vue';
import EntityConfiguration from '@/src/components/entity-configuration.vue';
import SheetConfiguration from '@/src/components/sheets/sheet-configuration.vue';
import BankAccounts from '@/src/components/bank-accounts/bank-accounts.vue';
import ColumnsConfiguration from '@/src/components/columns-configuration.vue';
import FiltersConfiguration from '@/src/components/filters-configuration.vue';
import FiltersSelector from '@/src/components/filters-selector.vue';
import OnboardingWizard from '@/src/components/onboarding/onboarding-wizard.vue';
import MarkdownSectionCard from '@/src/components/markdown-section-card.vue';
import TutorialHeader from '@/src/components/tutorials/tutorial-header.vue';
import currency from '@/src/filters/currency';
import textLimit from '@/src/filters/text_limit';
import date from '@/src/filters/date';
import dateTime from '@/src/filters/dateTime';
import relativeTime from '@/src/filters/relativeTime';
import rut from '@/src/filters/rut';
import time from '@/src/filters/time';
import '@/css/application.css';
import store from '@/src/store/index';
import Locales from '@/locales/locales.js';
import LandingHero from '@/src/components/landing/landing-hero.vue';
import LandingFooter from '@/src/components/landing/landing-footer.vue';
import LandingInfo from '@/src/components/landing/landing-info.vue';
import LandingInfoCard from '@/src/components/landing/landing-info-card.vue';
import LandingTab from '@/src/components/landing/landing-tab.vue';
import LandingInvite from '@/src/components/landing/landing-invite.vue';
import LandingNavbar from '@/src/components/landing/landing-navbar.vue';
import Btn from '@/src/components/btn.vue';
import FaqHeader from '@/src/components/landing/faq-header.vue';

Vue.use(Button);
Vue.use(Checkbox);
Vue.use(Datepicker);
Vue.use(Dialog);
Vue.use(Dropdown);
Vue.use(Field);
Vue.use(Icon);
Vue.use(Input);
Vue.use(Loading);
Vue.use(Numberinput);
Vue.use(Radio);
Vue.use(Select);
Vue.use(Steps);
Vue.use(Switch);
Vue.use(Table);
Vue.use(Tag);
Vue.use(Taginput);
Vue.use(Toast);
Vue.use(Tooltip);
Vue.use(VModal);
Vue.use(VueCookies);
Vue.use(ActionCableVue, {
  debug: true,
  debugLevel: 'error',
  connectionUrl: import.meta.env.VITE_RAILS_ENV === 'production' ?
    (`wss://${import.meta.env.VITE_APPLICATION_HOST}/cable`) : 'ws://localhost:3000/cable',
  connectImmediately: true,
});
Vue.use(PiniaVuePlugin);
Vue.use(VueI18n, { bridge: true });
const i18n = createI18n({
  locale: 'es',
  messages: Locales.messages,
}, VueI18n);
Vue.use(i18n);

Vue.component('inline-svg', InlineSvg);
Vue.component('multiselect', Multiselect);

Vue.filter('camelizeKeys', camelizeKeys);
Vue.filter('currency', currency);
Vue.filter('date', date);
Vue.filter('dateTime', dateTime);
Vue.filter('relativeTime', relativeTime);
Vue.filter('time', time);
Vue.filter('textLimit', textLimit);
Vue.filter('rutFilter', rut);

Vue.directive('rut', rutInputDirective);

document.addEventListener('DOMContentLoaded', () => {
  const pinia = createPinia();

  const app = new Vue({
    el: '#vue-app',
    components: {
      navbar,
      BankMovements,
      MembersList,
      FintocWidget,
      SessionHandler,
      EntityConfiguration,
      SheetConfiguration,
      BankAccounts,
      ColumnsConfiguration,
      FiltersConfiguration,
      OnboardingWizard,
      LandingFooter,
      Btn,
      LandingInfo,
      LandingInfoCard,
      LandingTab,
      LandingHero,
      LandingInvite,
      LandingNavbar,
      FaqHeader,
      MarkdownSectionCard,
      FiltersSelector,
      TutorialHeader,
    },
    store,
    i18n,
    pinia,
  });

  return app;
});
